"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeBodyScrollLock = exports.addBodyScrollLock = void 0;
var addBodyScrollLock = function addBodyScrollLock() {
  var body = document.querySelector('body');
  if (body instanceof Element) {
    body.style.position = 'fixed';
    body.style.overflow = 'hidden';
    body.style.height = '100vh';
    body.style.width = '100%'; // Class required for Optimizely tests

    body.classList.add('mobile-nav--open');
  } else {
    // eslint-disable-next-line no-console
    console.error('valid `body` element not provided');
  }
};
exports.addBodyScrollLock = addBodyScrollLock;
var removeBodyScrollLock = function removeBodyScrollLock() {
  var body = document.querySelector('body');
  if (body instanceof Element) {
    body.style.position = '';
    body.style.overflow = '';
    body.style.height = '';
    body.style.width = '';
    body.classList.remove('mobile-nav--open');
  } else {
    // eslint-disable-next-line no-console
    console.error('valid `body` element not provided');
  }
};
exports.removeBodyScrollLock = removeBodyScrollLock;